/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-14 10:50:40
 */ 
export const vistedRecordsEn = {
    xunjiadang:'Browse record',
    dingdangbianhao:'Please enter keywords',
    sousuo:'search',
    quanxuan:'All',
    sanchu:'Delete',
    fuwuxinxi:'Service information',
    zhiliaoxinxi:'material information',
    kechengxinxi:'course information ',
    hzuanjiaxinxi:"expert's information",
    lioulanshijian:'Browsing time',
    caozuo:'operation',
    renzhengfuwu:'authentication service',
    ziliaowenku:'The data library',
    peixunfuwu:'training service ',
    zhuanjiazhixun:'expert consultation',
}


// WEBPACK FOOTER //
// ./src/lang/member/vistedRecords/vistedRecordsEn.js